import React from "react"
// import './PayPerClickAds.css'
import payPerClickAds from '../../assets/bannerImages/payPerClickMarketing.jpg'
import monitoringTheDeviation from '../../assets/images/monitoringTheDeviation.webp'
import googleadsLogo from '../../assets/logos/googleadsLogo.jpg'
import metaadsLogo from '../../assets/logos/metaadsLogo.jpg'
import microsoftadsLogo from '../../assets/logos/microsoftadsLogo.jpg'
import linkedinLogo from '../../assets/logos/linkedinLogo.jpg'
import { Link } from "react-router-dom"

import targetedCampaigns from '../../assets/images/targetedCampaign.jpg'
import maximizedROI from '../../assets/images/maximizedROI.jpg'
import tailoredStrategies from '../../assets/images/targetedStrategies.jpg'

import keywordResearch from '../../assets/images/keywordResearch.jpg'
import adCreationAndOptimization from '../../assets/images/adCreationAndOptimization.jpg'
import continuousMonitoringAndImprovement from '../../assets/images/continuousMonitoringAndImprovement.jpg'


export default function PayPerClickAds(){
    return(
        <div className="payPerClickAds">
            <PPCAR1/>
            <PPCAR2/>
            <PPCAR3/>
            <PPCAR4/>
            <PPCAR5/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function PPCAR1(){
    return(
        <div className='ppcar1'>
            <img loading="lazy" src={payPerClickAds} alt='ppca-banner' className='ppca-banner-img'/>
            <h1 className='ppcar1-head'>Pay Per Click Ads</h1>
            <div className='overlay'></div>
        </div>
    )
}

function PPCAR2(){
    return(
        <div className='ppcar2'>
            <div className='strip'>
                <h1>What Are <span>Pay-Per-Click Ads</span>?</h1>
                <hr/>   
                <p>Pay-per-click (PPC) ads are a type of online advertising where businesses pay only when their ad is clicked. It's a cost-effective way to target potential customers who are actively searching for products or services. With PPC, businesses can control their budget, choose specific keywords, and track performance easily. This method often leads to better results compared to traditional advertising.</p>
            </div>
        </div>
    )
}

function PPCAR3(){
    return(
        <div className='ppcar3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Pay-Per-Click Ads?
                </h1>
                <p className='rowThreeContext'>
                    Looking to maximize your online visibility and drive targeted traffic to your website? 
                    Bixian specializes in crafting effective Pay Per Click (PPC) advertising campaigns tailored to your business goals. 
                    Our team of PPC experts will work closely with you to understand your objectives and develop a strategy that ensures your ads reach the right audience at the right time. 
                    With Bixian, you can trust that your PPC budget will be invested wisely, driving maximum ROI and helping your business thrive online.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={targetedCampaigns} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Targeted Campaigns
                            </h2>
                            <p className='boxPara'>
                            We specialize in creating precise PPC campaigns, reaching the right audience for maximum impact.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={maximizedROI} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Maximized ROI
                            </h2>
                            <p className='boxPara'>
                            Expect high returns with our optimized PPC ads, driving more leads and sales to grow your business.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={tailoredStrategies} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Tailored Strategies
                            </h2>
                            <p className='boxPara'>
                            Benefit from custom PPC plans designed to suit your unique goals and industry needs, ensuring effective advertising.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function PPCAR4(){
    return(
        <div className='ppcar4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    At Bixian, we believe in simplicity and effectiveness when it comes to Pay-Per-Click (PPC) Ads. We start by understanding your goals and audience, then craft a tailored plan for success. With us, you're more than a client; you're a valued partner in every step of your PPC journey..
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={keywordResearch} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Keyword Research</h2>
                        <p className='boxPara'>We start by identifying relevant keywords and phrases that your target audience is likely to use when searching for products or services similar to yours.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={adCreationAndOptimization} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Ad Creation and Optimization</h2>
                        <p className='boxPara'> Next, we craft compelling ad copy and design eye-catching visuals to attract clicks. Constant monitoring and optimization ensure that your ads perform at their best.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={continuousMonitoringAndImprovement} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Continuous Monitoring and Improvement</h2>
                        <p className='boxPara'> We keep a close eye on your PPC campaigns, making adjustments as needed to ensure optimal performance and maximize your return on investment (ROI).</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function PPCAR5(){
    return(
        <div className='ppcar5'>
            <h1 className='rowFiveHead'>Where <span>Your Ads</span> Are Displayed?</h1>
            <div className='container'>
                <div className='item facebook'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={googleadsLogo} alt='' className='smLogo'/>
                </div>
                <div className='item instagram'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={metaadsLogo} alt='' className='smLogo'/>

                </div>
                <div className='item youtube'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={microsoftadsLogo} alt='' className='smLogo'/>

                </div>
                <div className='item linkedin'>
                    <div className='whiteBackground'></div>
                    <img loading="lazy" src={linkedinLogo} alt='' className='smLogo'/>

                </div>
                
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Pay-Per-Click Ads?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}
